import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const FacebookIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 36 36" {...props}>
            <path
                d="M27 3H22.5C20.5109 3 18.6032 3.79018 17.1967 5.1967C15.7902 6.60322 15 8.51088 15 10.5V15H10.5V21H15V33H21V21H25.5L27 15H21V10.5C21 10.1022 21.158 9.72065 21.4393 9.43934C21.7206 9.15804 22.1022 9 22.5 9H27V3Z"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};
